<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>工资发放说明:</h5><br>
        <span>1、统计已经完成工资发放的员工信息!</span><br>
        <span>2、查询关键字:单号、部门、人员。<span class="red">默认本月</span></span><br>
        <span>3、发放日期如果不填<span class="red">默认当天</span></span><br>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
      <!-- <template slot="pre_base_button">
        <button class="pre_btn_ok" @click="fun_build">计算所有人员工资</button>
      </template> -->

    </pre-base>

  </div>
</template>

<script>
  import api from '@/utils/type.js';
  import {
    Method_EasySelect,
    Method_Common
  } from '@/utils/loadhttpdata.js';

  import {
    getNowDateTime,
    dateFormatEasybyChina
  }
  from '@/utils/method.js';

  export default {
    components: {
      "pre-base": () => import("../auto/pre_mode_v2.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',
        // 下拉菜单
        // list_fee: [],
        // sel_fee: {},
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: async function() {
        // action_flag  方法选择

        this.init_data = '';
        this.init_data = JSON.stringify({
          "title": '工资发放',
          "control": "usersalarypay",
          "isFileMain":"1",
          "action_flag":"",
          "sel_action": 'exp_salaryallpay',
          "upd_action": 'salaryallpay',
          // "step": '1',
          "d_sel_action": 'exp_salary_d',
          "d_upd_action": '',
          "file_action": '',
          "p1": '',
          "p2": '',
          "p3": '',
          "parm_sel": [
            {
              "name": "账号",
              "val": "",
              "key": "sheet_no",
              "type": "text",
              "class": "long1",
              "sel": "1",
              "note": "按账号查询"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "select",
              "class": "long1",
              "sel_action": "data_base_dep",
              "sel_name": "",
              "sel": "2"
            },
            {
              "name": "申请人",
              "val": "",
              "key": "u2_name",
              "type": "select",
              "class": "long1",
              "sel_action": "data_alluser",
              "sel_name": "",
              "sel": "3"
            },
            {
              "name": "月份",
              "val": new Date(),
              "key": "month",
              "type": "month",
              "class": "long1",
              "sel": "4"
            }
          ],
          "parm": [
            {
              "name": "单号",
              "val": "",
              "key": "sheet_no",
              "class": "long1",
              "type": "text",
              "r": "1",
              "p": "1",
              "x": "1"
            },
            {
              "name": "部门",
              "val": "",
              "key": "d_name",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "1"
            },
            {
              "name": "人员",
              "val": "",
              "key": "u2_name",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "1"
            },
            {
              "name": "基本工资",
              "val": "",
              "key": "s_base",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "岗位工资",
              "val": "",
              "key": "s_role",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "交通补贴",
              "val": "",
              "key": "s_butie",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "餐补",
              "val": "",
              "key": "can_bu",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "话补",
              "val": "",
              "key": "hua_bu",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "应发总额",
              "val": "",
              "key": "all_amount",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "2"
            },
            {
              "name": "计薪基数",
              "val": "",
              "key": "s_level",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "应工作天数",
              "val": "",
              "key": "day_all",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "出勤",
              "val": "",
              "key": "day_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "缺勤",
              "val": "",
              "key": "day_no",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "全勤奖励",
              "val": "",
              "key": "s_day_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "缺勤罚款",
              "val": "",
              "key": "s_day_no",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "应发工资",
              "val": "",
              "key": "s_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "3"
            },
            {
              "name": "借款抵扣",
              "val": "",
              "key": "s_jk_yz",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "4"
            },
            {
              "name": "打卡",
              "val": "",
              "key": "secord_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "4"
            },
            {
              "name": "日志",
              "val": "",
              "key": "workbook_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "4"
            },
            {
              "name": "社保",
              "val": "",
              "key": "s_sb",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "5"
            },
            {
              "name": "公积金",
              "val": "",
              "key": "zhufang_gjj",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "5"
            },
            {
              "name": "个税",
              "val": "",
              "key": "s_shui",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "5"
            },
            {
              "name": "绩效",
              "val": "",
              "key": "s_jx",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "5"
            },
            {
              "name": "其他",
              "val": "",
              "key": "s_other",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "5"
            },
            {
              "name": "应发总额",
              "val": "",
              "key": "all_amount",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "6"
            },
            {
              "name": "本月应发工资",
              "val": "",
              "key": "s_ok",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "6"
            },
            {
              "name": "本月实发工资",
              "val": "",
              "key": "s_end",
              "type": "text",
              "class": "long1",
              "r": "1",
              "x": "6"
            },
            {
              "name": "备注",
              "val": "",
              "key": "note",
              "type": "textarea",
              "class": "long3",
              "r": "1",
              "x": "7"
            },
            {
              "name": "发放状态",
              "val": "",
              "key": "flag",
              "type": "radio",
              "class": "long1",
              "list":[{"id":"1","val":"待处理"},{"id":"2","val":"完成"}],
              "sel_action":"",
              "p": "1",
              "x": "8"
            },
            {
              "name": "发放日期",
              "val": "",
              "key": "pay_date",
              "type": "date",
              "class": "long1",
              "p": "1",
              "x": "8"
            },
            {
              "name": "发放说明",
              "val": "",
              "key": "pay_note",
              "type": "text",
              "class": "long5",
              "p": "1",
              "x": "8"
            },
          ],
          "parm_th": [{
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "角色"
            },
            {
              "name": "部门"
            },
            {
              "name": "人员姓名"
            },
            {
              "name": "开始日期"
            },
            // {
            //   "name": "结束日期"
            // },
            {
              "name": "发放状态"
            },
            {
              "name": "发放日期"
            },
            {
              "name": "发放备注"
            },
            {
              "name": "发放人员"
            },
            {
              "name": "基本工资"
            },
            {
              "name": "岗位工资"
            },
            {
              "name": "交通补贴"
            },
            {
              "name": "餐补"
            },
            {
              "name": "话补"
            },
            {
              "name": "应发总额"
            },
            {
              "name": "计薪基数"
            },
            {
              "name": "应工作天数"
            },
            {
              "name": "实际工作天数"
            },
            {
              "name": "缺勤工作天数"
            },
            {
              "name": "全勤奖励"
            },
            {
              "name": "缺勤罚款"
            },
            {
              "name": "本月应发工资"
            },

            {
              "name": "打卡"
            },
            {
              "name": "日志"
            },

            {
              "name": "预支|借款"
            },
            {
              "name": "罚款"
            },
            {
              "name": "违章"
            },


            {
              "name": "奖励"
            },
            {
              "name": "社保"
            },
            {
              "name": "住房公积金"
            },
            {
              "name": "个人所得税"
            },
            {
              "name": "绩效"
            },
            {
              "name": "其他"
            },
            {
              "name": "实际发放"
            },
            {
              "name": "备注"
            },
            {
              "name": "录入人"
            },
            {
              "name": "更新时间"
            }
          ],
          "d_parm": [],
          "d_name": [{
              "name": "ID"
            },
            {
              "name": "序号"
            },
            {
              "name": "单号"
            },
            {
              "name": "相关业务单号"
            },
            {
              "name": "费用名称"
            },
            {
              "name": "费用金额"
            },
            {
              "name": "费用类型"
            },
            {
              "name": "备注"
            },
            {
              "name": "录入人"
            },
            {
              "name": "更新时间"
            }
          ]
        });

      },
      refresh_data: function() {
        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase'].refresh_data();
        });
      },
      refresh_father: function(type, val, parm) {
        // console.log('type=' + type + ' val=' + val);
        // switch (type) {
        //   case 'father':
        //     // 弹出修改明细，修改主窗口信息
        //     this.refresh_data();
        //     break;
        //   default:
        //     // console.log('子组件刷新父组件传值=' + val);
        //     this.row_id = val;
        //     this.item = parm;
        //     break;
        // }
      }

    }
  };
</script>
<style scoped="scoped">
  .top_sheetno {
    position: absolute;
    top: 16%;
    left: 10%;
    background-color: rgba(0, 0, 0, 0.5);
    /* opacity: 0.2; */
    /* border: 1px solid black; */
    /* padding-left: 20px; */
    /* padding-right: 20px; */
    border-radius: 5px;
    z-index: 3;
    width: 80%;
    text-align: center;
    padding: 20px;
    overflow-x: auto;
  }

  .top_sheetno_close>img {
    width: 24px;
    height: auto;
    position: absolute;
    right: 24px;
    top: 24px;
    cursor: pointer;
  }

  .salary {
    padding-bottom: 20px;
  }

  .salary>div {
    margin-top: 10px;
  }

  .salary-edit {
    display: inline-block;
    width: 100%;
  }

  .salary-edit>label {
    display: inline-block;
    width: 108px;
  }
</style>
